/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from "axios";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
var moduleName = "Holiday";
var modulePath = "/clientpanel/holiday";
const enableSMSCampaign = cookie.load("enableSMSCampaign") ?? "false";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      postdata: {
        holidayName: "",
        holidayDate: "",
        holidayDescription: "",
        holidaySMSDescription: "",
        holidayStatus: "",
        action: "add",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: `${apiUrl}holiday/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost != nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var statuss = result.holidayStatus == "A" ? "Active" : "Inactive";
          var holidayStatus =
            result.holidayStatus !== "" && result.holidayStatus !== null
              ? {
                  label: statuss,
                  value: result.holidayStatus,
                }
              : "";
          var clientupdatedata = {
            holidayName: result.holidayName,
            holidayDate: result.holidayDate !== null && result.holidayDate !== "" ? new Date(result.holidayDate) : "",
            holidayDescription: result.holidayDescription,
            holidaySMSDescription: result.holidaySMSDescription,
            holidayStatus: holidayStatus,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    const editorContent = $("#editorContent").val();
    var postObject = {
      holidayName: postData.holidayName,
      holidayDate: postData.holidayDate !== "" ? format(postData.holidayDate, "yyyy-MM-dd") : "",
      holidayDescription: editorContent,
      holidaySMSDescription: postData.holidaySMSDescription,
      holidayStatus: Object.keys(postData.holidayStatus).length > 0 ? postData.holidayStatus.value : "A",
    };

    var post_url = "client/holiday";
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `client/holiday/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"holiday"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          100
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { holidayName, holidayDate, holidayStatus } = props.fields;

  return {
    fields: ["holidayName", "holidayDate", "holidayStatus"],
    validations: {
      holidayName: [[isEmpty, holidayName]],
      holidayDate: [[isEmpty, holidayDate]],
      holidayStatus: [[isSingleSelect, holidayStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  setContent(value) {
    this.props.onChange("holidayDescription", value);
  }

  getAIData() {
    if (this.props.fields.holidayName !== "") {
      this.setState({ errorMag: false });
      showLoader("searchAI");
      var postObject = {
        searchKeyWord: this.props.fields.holidayName,
        type: "holiday",
      };
      axios.post(apiUrl + "master/getAIData", postObject, clientheaderconfig).then((res) => {
        hideLoader("searchAI");
        if (res.data.status === "ok") {
          console.log(res.data, "res.datares.datares.data");
          this.props.onChange("holidaySMSDescription", res.data.title);
          setTimeout(() => this.props.onChange("holidayDescription", res.data.description), 1000);
        }
      });
    } else {
      this.setState({ errorMag: true });
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgholidayName,
      errMsgStatus,
      errMsgholidayDate = "";
    if ($validation.holidayName.error.reason !== undefined) {
      errMsgholidayName = $validation.holidayName.show && <span className="error">{$validation.holidayName.error.reason}</span>;
    }
    if ($validation.holidayDate.error.reason !== undefined) {
      errMsgholidayDate = $validation.holidayDate.show && <span className="error">{$validation.holidayDate.error.reason}</span>;
    }

    if ($validation.holidayStatus.error.reason !== undefined) {
      errMsgStatus = $validation.holidayStatus.show && <span className="error">{$validation.holidayStatus.error.reason}</span>;
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 mt-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4" id="searchAI">
              <input
                type="text"
                className={errMsgholidayName !== "" && errMsgholidayName !== false && errMsgholidayName !== undefined ? "form-control is-invalid" : "form-control"}
                name="holidayName"
                value={fields.holidayName}
                {...$field("holidayName", (e) => onChange("holidayName", e.target.value))}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    this.getAIData();
                  }
                }}
              />
              <label htmlFor="holidayName">
                Holiday <span className="error">*</span>
              </label>
              {errMsgholidayName}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4 custm-date-box">
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.holidayDate}
                dateFormat="dd/MM/yyyy"
                onChange={this.handleChange.bind(this, "holidayDate")}
              />
              <label className="select-box-label">Holiday Date</label>
              {errMsgholidayDate}
            </div>
          </div>
          <div className="col-md-6">
            <label>Description</label>
            <textarea className="form-control" value={fields.holidaySMSDescription} {...$field("holidaySMSDescription", (e) => onChange("holidaySMSDescription", e.target.value))} rows={8}></textarea>
          </div>
          <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.holidayStatus}
                onChange={this.handleSelectChange.bind(this, "holidayStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          {enableSMSCampaign === "true" && (
            <div className="col-md-12">
              <label>Email Description</label>
              <Editor IDName={"editorContent"} data={fields.holidayDescription} />
            </div>
          )}

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
